/**
 * @file: ErpSyncDirection.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpSyncDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

export const ErpSyncDirectionValueSet = new Set([
  ErpSyncDirection.Inbound,
  ErpSyncDirection.Outbound,
]);
